import enCompanySurveys from './en';
import ruCompanySurveys from './ru';

import analytics from './analytics/';

export default {
  en: {
    ...enCompanySurveys,
    ...analytics.en,
  },
  ru: {
    ...ruCompanySurveys,
    ...analytics.ru,
  },
};
